module.exports = __webpack_public_path__ + "img/base.9ba4812d.png";